import React, { useRef, useState } from "react";
import { Modal, Tooltip } from "antd";
import { ProfileOutlined, UserOutlined } from "@ant-design/icons";
import { map, filter, find, get, isEmpty } from "lodash";
import "./detailsOfUser.scss";
import type { DraggableData, DraggableEvent } from "react-draggable";
import Draggable from "react-draggable";

const ExtraDetailsOfUser = (props: {
  record: {
    [x: string]: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined;
    member_first_name: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined;
    member_last_name: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined;
    file_name: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined;
    additionalInfo: any;
  };
  columnListForPopUp: any;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 });
  const draggleRef = useRef<HTMLDivElement>(null);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) {
      return;
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };

  return (
    <>
      <Tooltip title="Patient Details">
        <UserOutlined onClick={() => showModal()} />
      </Tooltip>
      <Modal
        modalRender={(modal) => (
          <Draggable disabled={disabled} bounds={bounds} onStart={(event, uiData) => onStart(event, uiData)}>
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
        width={500}
        centered
        title={
          <div
            style={{
              width: "100%",
              cursor: "move",
              display: "flex",
            }}
            onMouseOver={() => {
              if (disabled) {
                setDisabled(false);
              }
            }}
            onMouseOut={() => {
              setDisabled(true);
            }}
          >
            <div className="ant-modal-title__title">Records Information:</div>
            <div className="ant-modal-title__name">
              {props.record?.member_first_name} {props.record?.member_last_name}
            </div>
            <div className="ant-modal-title__file"> {props.record?.file_name}</div>
          </div>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className={"ui-empi-extra-details"}
        footer={[]}
      >
        <div className="ui-empi-extra-details__table">
          <div className="ui-empi-extra-details__table__header">
            <div className="ui-empi-extra-details__table__header__column">Description</div>
            <div className="ui-empi-extra-details__table__header__column">Value</div>
          </div>
          {map(
            filter(props.columnListForPopUp, (column) => column?.dataIndex !== "rec_group_id" && column?.dataIndex !== "member_unique_id"),
            (item) => {
              return (
                <div key={item?.dataIndex} className="ui-empi-extra-details__table__body">
                  <div className="ui-empi-extra-details__table__body__column">{item.tableHeaderName}</div>
                  <div className="ui-empi-extra-details__table__body__column">{props.record?.[item.dataIndex] || "--"}</div>
                </div>
              );
            }
          )}

          {map(props?.record?.additionalInfo, (item) => {
            return (
              <div key={item?.dataIndex} className="ui-empi-extra-details__table__body">
                <div className="ui-empi-extra-details__table__body__column">{item.tableHeaderName}</div>
                <div className="ui-empi-extra-details__table__body__column">{item.column_value || "--"}</div>
              </div>
            );
          })}
        </div>
      </Modal>
    </>
  );
};

export default ExtraDetailsOfUser;

export const ExtraDetailsOfUserComparison = (props: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 });
  const draggleRef = useRef<HTMLDivElement>(null);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const additionalInfoHeaderArray: any = new Set(
    map([...props?.record?.additionalInfo, ...get(props, "record.target.additionalInfo", [])], (_item) => {
      return _item.tableHeaderName;
    })
  );

  const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) {
      return;
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };

  return (
    <>
      <Tooltip title="Source and Destination Details">
        <ProfileOutlined onClick={() => showModal()} />
      </Tooltip>
      <Modal
        modalRender={(modal) => (
          <Draggable disabled={disabled} bounds={bounds} onStart={(event, uiData) => onStart(event, uiData)}>
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
        width={1000}
        centered
        title={
          <div
            style={{
              width: "100%",
              cursor: "move",
              display: "flex",
            }}
            onMouseOver={() => {
              if (disabled) {
                setDisabled(false);
              }
            }}
            onMouseOut={() => {
              setDisabled(true);
            }}
          >
            <div className="ant-modal-title__title">Records Information:</div>
            <div className="ant-modal-title__name">
              {props.record?.member_first_name} {props.record?.member_last_name}
            </div>
            <div className="ant-modal-title__file"> {props.record?.file_name}</div>
          </div>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className={"ui-empi-extra-details"}
        footer={[]}
      >
        <div className="ui-empi-extra-details__table">
          <div className="ui-empi-extra-details__table__header">
            <div className="ui-empi-extra-details__table__header__column">Description</div>
            <div className="ui-empi-extra-details__table__header__column">Source</div>
            <div className="ui-empi-extra-details__table__header__column">Destination</div>
          </div>
          {map(
            filter(props.columnListForPopUp, (column) => column?.dataIndex !== "rec_group_id" && column?.dataIndex !== "member_unique_id"),
            (item) => {
              return (
                <div key={item?.dataIndex} className="ui-empi-extra-details__table__body">
                  <div className="ui-empi-extra-details__table__body__column">{item.tableHeaderName}</div>
                  <div className="ui-empi-extra-details__table__body__column">
                    {item.tableHeaderName === "EMPI ID" && isEmpty(props.record?.[item.dataIndex]) ? "To Be Assigned" : props.record?.[item.dataIndex] || "--"}
                  </div>
                  <div className="ui-empi-extra-details__table__body__column">{props.record?.target?.[item.dataIndex] || "--"}</div>
                </div>
              );
            }
          )}

          {map([...additionalInfoHeaderArray], (item: any) => {
            return (
              <div key={`${item?.dataIndex}info`} className="ui-empi-extra-details__table__body">
                <div className="ui-empi-extra-details__table__body__column">{item}</div>
                <div className="ui-empi-extra-details__table__body__column">{find(props?.record?.additionalInfo, { tableHeaderName: item })?.column_value || "--"}</div>
                <div className="ui-empi-extra-details__table__body__column">{find(props.record?.target?.additionalInfo, { tableHeaderName: item })?.column_value || "--"}</div>
              </div>
            );
          })}
        </div>
      </Modal>
    </>
  );
};
